import {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useState,
} from 'react'

type PortalNodeType = HTMLDivElement | null

interface SchemaBuilderRowContextInterface {
  propertiesRef: PortalNodeType
  setPropertiesRef: Dispatch<SetStateAction<PortalNodeType>>
}

const SchemaBuilderRowContext = createContext<SchemaBuilderRowContextInterface>(
  {
    propertiesRef: null,
    setPropertiesRef: () => {},
  },
)

export function SchemaBuilderRowContextProvider({ children }) {
  const [propertiesRef, setPropertiesRef] = useState<PortalNodeType>(null)

  const value = {
    propertiesRef,
    setPropertiesRef,
  }

  return (
    <SchemaBuilderRowContext.Provider value={value}>
      {children}
    </SchemaBuilderRowContext.Provider>
  )
}

export function useSchemaBuilderRowContext() {
  return useContext(SchemaBuilderRowContext)
}
